export default function HowToJoinCN() {
  return (
    <>
   <h2>如何参加：</h2>
    1. 开始：使用您登記的护照登录即可开始。如果您是第一次到訪，只需点击「登記」並开始。<br/>
    2. 试试您的运气：想看看您有多幸运吗？点击「测试您的运气」，开始游戲吧！<br/>
    3. Biggy的飞溅挑战：按下鲜红色按钮，让球飞起来。目标简单但令人兴奋，因為您永远不知道氣球会落在哪里，因为这全凭运气！<br/>
    4. 获胜：
要获胜，只需在3次機會中击中目标2次。如果您错过了，别担心，你还是會有奖励的！<br/>
    5. 奖品：<br/>
头奖：获胜者将获得价值300泰铢的優惠券，可在无最低消费的情况下使用。<br/>
其他奖品：如果您没有获胜，有完成游戲也可以获得电子优惠券。<br/>
    6. 如何使用您的优惠券：只需在全国任何Big C商店出示您登記的护照即可领取您的奖品。<br/>
   <br/> <br/>
    <h2>指导之星 - 条款和条件： </h2>
    1. 每位探险者仅一次旅程：每位顾客只有一次游玩机会。<br/>
    2. 一本护照，一次机会：确保您的护照准备好参与这次独家冒险。<br/>
    3. 优惠券有效期：您的电子优惠券自发放之日起30天内有效。<br/>
    4. 仅限入境游客：这场销活动专为勇敢的国际访客来泰国量身定制。<br/>
    5. 从2024年4月1日起至2024年5月31日止。<br/>
    6. 公司指引：公司制定的额外指引均适用。<br/>


    <br/> <br/>
    <h2>更多冒险，密切留意</h2>
    <br/> <br/>
    Facebook: <a href="https://www.facebook.com/BigCTouristsFavoritesTH" target="_blank" class="consent-link">https://www.facebook.com/BigCTouristsFavoritesTH</a><br/>
    Instagram: <a href="https://www.instagram.com/bigc.th/" target="_blank" class="consent-link">https://www.instagram.com/bigc.th/</a><br/>
    微信： <a href="https://mp.weixin.qq.com/s/LYI0Vt8y6-O3TTfmHkiVDw" target="_blank" class="consent-link">https://mp.weixin.qq.com/s/LYI0Vt8y6-O3TTfmHkiVDw</a><br/>
    <br/> <br/>
    <h2>立即參與遊戲，贏取豐富獎勵！</h2>

    
    </>
  );
}
